<template>
	<div class="watch-readings-menu">
		<button @click="prev()" :disabled="selected < 2">&lt;</button>
		<router-link
			v-for="link in links"
			:key="link.id"
			:to="{ name: 'WatchBiometricView', params: { user_uid: user_uid, watch_id: watch_id, type: type(link.id) } }">
			<div class="container">
				<svgicon :name="icon(link.type)" :fill="false"/>
				<div v-if="alertMap.has(link.id)" class="alerts-number">{{ alertMap.get(link.id) }}</div>
			</div>
			<span class="reading-type-name">{{ link.text }}</span>
		</router-link>
		<button @click="next()" :disabled="selected > this.links.length - 1">&gt;</button>
	</div>
</template>

<script>
import Readings from '@/utils/readings'
export default {
	props: [
		'user_uid',
		'watch_id',
		'selected'
	],
	data () {
		return {
			selectedIndex: this.selected,
		}
	},
	computed: {
		links () {
			return [
				{
					id: 1,
					type: Readings.TYPE_HEART_RATE,
					text: this.$t('readings.hearthrate.name')
				},
				{
					id: 2,
					type: Readings.TYPE_BLOOD_PRESSURE,
					text: this.$t('readings.bloodpressure.name')
				},
				{
					id: 3,
					type: Readings.TYPE_TEMPERATURE,
					text: this.$t('readings.temperature.name')
				},
				{
					id: 4,
					type: Readings.TYPE_BLOOD_SATURATION,
					text: this.$t('readings.bloodsaturation.name')
				},
				{
					id: 6,
					type: Readings.TYPE_CALORIES,
					text: this.$t('readings.calories.name')
				},
				{
					id: 7,
					type: Readings.TYPE_PEDOMETER,
					text: this.$t('readings.pedometer.name')
				},
				{
					id: 8,
					type: Readings.TYPE_FALLS,
					text: this.$t('readings.falls.name')
				}
			]
		},
		alerts () {
			return this.$store.getters.getAccountAlertsUnread(this.user_uid)
		},
		alertMap () {
			const map = new Map()
			this.links.forEach(element => {
				const count = this.alertCountByType(element.id)
				if (count) {
					map.set(element.id, count)
				}
			})
			return map
		}
	},
	watch: {
		selected () {
			this.selectedIndex = this.selected
		},
		selectedIndex () {
			this.$router.push({ name: this.links[this.selectedIndex - 1].name, params: { user_uid: this.user_uid, watch_id: this.watch_id } })
		}
	},
	methods: {
		prev () {
			if (this.selectedIndex > 1) {
				this.selectedIndex--;
			}
		},
		next () {
			if (this.selectedIndex < this.links.length) {
				this.selectedIndex++;
			}
		},
		icon (type) {
			return Readings.readingTypes.get(type).icon
		},
		type (type) {
			return Readings.readingTypes.get(type).route
		},
		alertCountByType (type) {
			return this.alerts.data.reduce((acc, val) => {
				return acc + (val.args.type == type ? 1 : 0)
			}, 0)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/ReadingsSubMenu.vue